import React, { Component, ReactFragment } from "react";
import { Card, CardBody, Row, Col , CardTitle, FormFeedback, CardHeader} from "reactstrap";
import { SlPageTitle, SlSectionTitle, TextInput, SlButton, SlRadioButton, SlBusyIndicator, SlFormEntryRow } from "../components/editors";
import { metadataService, AccountAPI } from "../_services";
import { MfaCodeEntry } from "./editors/MfaCodeEntry";
import { history } from "../_helpers"
import validator from "validator";


export class ForgotPassword extends Component {
  static displayName = ForgotPassword.name;
  STAGE_GET_ID_NUMBERS = 0; 
  STAGE_SELECT_MFA_TARGET = 1; 
  STAGE_VALIDATE_MFA = 2; 
  STAGE_SET_PASSWORD = 3;
  STAGE_COMPLETE = 4; 
  STAGE_FAILED = 5; 

  constructor(props) {
    super(props);
    this.state = {
      SSN: '',
      DOB: '',
      mfaCode: ['', ''],
      tokenId: '',
      password: '',
      verifyPassword: '',
      isBusy: false,
      canMoveNext: false,
      currentStage: 0,
      pageError: '',
      idType: "SSN",
      SSNString: "SSN",
      MCString: "MC",
      validIDLabel: "ValidSSN",
      isIdValid: true,
    }

    this.handleInputChange = this.handleInputChange.bind(this);
    this.setMoveNext = this.setMoveNext.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleMfaCodeUpdated = this.handleMfaCodeUpdated.bind(this);
    this.handleMfaValidate = this.handleMfaValidate.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.setPageError = this.setPageError.bind(this);
  }

  setMoveNext(stateChanges) {
    const newState = { ...this.state, ...stateChanges };
    let canMoveNext =  this.isStateValid(newState, this.state.currentStage);
    
    return { ...stateChanges, ...{  canMoveNext: canMoveNext } };
  }



  isStateValid(currentState, currentStage) {
    switch (currentStage) {
      case this.STAGE_GET_ID_NUMBERS:
        const numericCaseRegEx = new RegExp("^[0-9]*$");
        let isIDValueFormatValid = false
        let idnumberError = validator.isEmpty(currentState.SSN);
        let dobError = validator.isEmpty(currentState.DOB);
        let isIdLengthValid = true;
        
        if (currentState.idType === currentState.SSNString &&
          currentState.SSN.length > 0) {
          isIDValueFormatValid = numericCaseRegEx.test(currentState.SSN);
          isIdLengthValid = currentState.SSN.length != 9 ? false : true;
          this.setState({ isIdValid: (isIDValueFormatValid && isIdLengthValid) });
        }
        else {
          isIDValueFormatValid = true;
          this.setState({ isIdValid: true });
        }

        return !idnumberError && !dobError && isIDValueFormatValid && isIdLengthValid;
            
      case this.STAGE_SELECT_MFA_TARGET:
        return (currentState.target)
            
      case this.STAGE_SET_PASSWORD:
        return (
          !validator.isEmpty(currentState.NewPassword + '') &&
          validator.equals(currentState.NewPassword + '', currentState.ConfirmPassword + '') &&
          metadataService.checkPasswordComplexity(currentState.NewPassword)
          //zxcvbn(this.state.NewPassword).score > 2 && 
        )
            
      case this.STAGE_COMPLETE:
        return true;
      default:

        break;
    }
    return false;
  }

  handleBack(e){
    const nextStage = this.state.currentStage !== this.STAGE_FAILED ? this.state.currentStage - 1: this.STAGE_GET_ID_NUMBERS
    const newState = {currentStage : nextStage, canMoveNext:this.isStateValid(this.state, this.state.currentStage - 1 ), pageError:''}
    this.setState(newState);
  }

  handleInputChange(event) {
    let targetName = event.target.name;

    if (targetName === this.state.SSNString) {
      this.setState({ validIDLabel: "ValidSSN" });
    } else if (targetName === this.state.MCString) {
      this.setState({ validIDLabel: "" });
    }

    let stateChanges ={}
    
    stateChanges[targetName] = event.target.value;
    
    const newState = this.setMoveNext(stateChanges);
    this.setState(newState);
}
handleSubmit(e){
    
    if(this.isStateValid(this.state, this.state.currentStage))
    {
      this.setPageError('');
      switch (this.state.currentStage) {
        case this.STAGE_SELECT_MFA_TARGET:
          this.setState({ isBusy: true })
          //Call the account api. 
          AccountAPI.sendMfaCodeToUserHash(this.state.SSN, this.state.DOB, this.state.target)
            .then(result => {
              if (result.status <= 1) {
                const mfaState = { currentStage: this.state.currentStage + 1, tokenId: result.data.tokenId, canMoveNext: false, isBusy: false };
                this.setState(mfaState)
              }
              else {
                this.setPageError(result.message);
              }
            })
          break;
        case this.STAGE_SET_PASSWORD:
          if (this.isStateValid(this.state, this.STAGE_SET_PASSWORD)) {
            this.setState({ isBusy: true })
            AccountAPI.resetUserPassword(this.state.tokenId, this.state.NewPassword)
              .then(result => {
                if (result.status <= 1) {
                  this.setState({ currentStage: this.STAGE_COMPLETE, isBusy: false })
                }
                else {
                  const newState = {
                    SSN: '',
                    DOB: '',
                    mfaCode: ['', ''],
                    tokenId: '',
                    password: '',
                    verifyPassword: '',
                    isBusy: false,
                    canMoveNext: false,
                    currentStage: this.STAGE_FAILED,
                    pageError: ''
                  }
                  this.setState(newState);
                }
              })
          }
          break;
        case this.STAGE_COMPLETE:
          history.push('/LoginMain')
          break;
        case this.STAGE_FAILED:
          this.setState({ currentStage: this.STAGE_GET_ID_NUMBERS, canMoveNext: this.isStateValid(newState, this.STAGE_GET_ID_NUMBERS) });
          break;
        default:
          const newState = { currentStage: this.state.currentStage + 1 }
          this.setState({ currentStage: this.state.currentStage + 1, canMoveNext: this.isStateValid(newState, this.state.currentStage + 1) })
    
      }
    }
}
handleMfaCodeUpdated(newMfaCode){
  this.setState({mfaCode : newMfaCode})
}
handleMfaValidate(){
  AccountAPI.validateMfaCodeAnon(this.state.tokenId, this.state.mfaCode, AccountAPI.MFA_REASON_RESET_PASSWORD)
    .then(
      r => {
        if(r.status <= 1){
          this.setState({currentStage: this.STAGE_SET_PASSWORD, canMoveNext: false})        
        }
        else{
          this.setPageError(r.message);
          //Error message
        }
      }
    )
}
setPageError(message){
  this.setState({pageError: message})
}
  render() {
    const { validIDLabel } = this.state;

    return (
      <div>
        <div id="backBtnContainer" style={{ height: "35px" }}>
          {this.state.currentStage !== this.STAGE_GET_ID_NUMBERS && (
            <SlButton name="Back" onClick={this.handleBack} />
          )}
        </div>
        <SlPageTitle pageName="ForgotPassword" />
        <SlBusyIndicator visible={this.state.isBusy} />
        {this.state.currentStage === this.STAGE_GET_ID_NUMBERS &&
          !this.state.isBusy && (
            <Card>
              {/* <CardHeader> */}
              {/* </CardHeader> */}

              <CardBody>

                <SlSectionTitle className={"p-3"} sectionName="ForgotPasswordIdentityLabel" />
                {/* <SlFormEntryRow>
                    <TextInput
                      name="SSN"
                      onChange={this.handleInputChange}
                      maxLength={10}
                      value={this.state.SSN}
                    />
                    </SlFormEntryRow> */}
                <SlFormEntryRow>
                  <TextInput
                    name="DOB"
                    type="date"
                    onChange={this.handleInputChange}
                    value={this.state.DOB}
                  />
                </SlFormEntryRow>
                <SlFormEntryRow>
                  <label>{metadataService.getLabel("IDType")}</label>
                  <br />
                  <SlRadioButton
                    fieldName="idType"
                    value="SSN"
                    isSelected={this.state.idType === "SSN"}
                    onChange={this.handleInputChange}
                  >
                    {" "}
                    {metadataService.getFieldNameLabel("SocialSecurityNumberSSN")}
                  </SlRadioButton>
                  <SlRadioButton
                    fieldName="idType"
                    value="MC"
                    isSelected={this.state.idType === "MC"}
                    onChange={this.handleInputChange}
                  >
                    {" "}
                    {metadataService.getFieldNameLabel("IndividualTaxIdentificationNumberITIN")}
                  </SlRadioButton>
                </SlFormEntryRow>
                <SlFormEntryRow>
                  <TextInput
                    name={"SSN"}
                    label={this.state.idType === "SSN"? metadataService.getFieldNameLabel("SocialSecurityNumberSSN") : metadataService.getFieldNameLabel("IndividualTaxIdentificationNumberITIN")}
                    value={this.state.SSN}
                    onChange={this.handleInputChange}
                  />
                  {this.state.idType === "SSN" && this.state.isIdValid === false ? (
                    <p className="warningTextNoPadding">
                      {metadataService.getLabel(validIDLabel)}
                    </p>
                  ) : (
                      <p></p>
                    )}
                </SlFormEntryRow>
              </CardBody>
            </Card>
          )}
        {this.state.currentStage === this.STAGE_SELECT_MFA_TARGET &&
          !this.state.isBusy && (
            <Card>
              <CardTitle >
                <p className='text-center'>{metadataService.getTitle("ForgotPasswordSubTitle")}</p>
                <p className='text-center'>{metadataService.getTitle("ForgotPasswordSubTitle1")}</p>
              </CardTitle>
              <CardBody>
                <SlFormEntryRow className='text-center'>
                    <SlRadioButton
                      fieldName="target"
                      value={AccountAPI.MFA_TARGET_EMAIL}
                      onChange={this.handleInputChange}
                    >
                      {metadataService.getFieldNameLabel("SendEmail")}
                    </SlRadioButton>
                    </SlFormEntryRow>
                    <SlFormEntryRow className='text-center'>
                    <SlRadioButton
                      fieldName="target"
                      value={AccountAPI.MFA_TARGET_TEXT}
                      onChange={this.handleInputChange}
                    >
                      {metadataService.getFieldNameLabel("SendText")}
                    </SlRadioButton>
                    </SlFormEntryRow>
              </CardBody>
            </Card>
          )}
        {this.state.currentStage === this.STAGE_VALIDATE_MFA &&
          !this.state.isBusy && (
            <MfaCodeEntry
              mfaSentMessage={metadataService.getMessage(
                "ForgotPasswordMfaSentMessage"
              )}
              value={this.state.mfaCode}
              valueUpdated={this.handleMfaCodeUpdated}
              onSubmit={this.handleMfaValidate}
              message=''
            />
          )}
        {this.state.currentStage === this.STAGE_SET_PASSWORD &&
          !this.state.isBusy && (
            <div>
              <Card>
                <CardBody>
                  <SlFormEntryRow>
                      <TextInput
                        name="NewPassword"
                        type="password"
                        value={this.state.NewPassword}
                        onChange={this.handleInputChange}
                        fieldErrors={this.state.fieldErrors}
                      />
                    </SlFormEntryRow><SlFormEntryRow>
                      <TextInput
                        name="ConfirmPassword"
                        type="password"
                        value={this.state.ConfirmPassword}
                        onChange={this.handleInputChange}
                        fieldErrors={this.state.fieldErrors}
                      />
                    </SlFormEntryRow>
                </CardBody>
              </Card>
              <Row className="justify-content-center">
                <Col xs={12} md={6}>
                  <p className="passwordHelpText">
                    {metadataService.getMessage("PasswordRequirements")}
                  </p>
                </Col>
              </Row>
            </div>
          )}
        {this.state.currentStage === this.STAGE_COMPLETE &&
          !this.state.isBusy && (
            <Card>
              <CardBody>
                <Row>
                  {metadataService.getMessage("ForgotPasswordChanged")}
                </Row>
              </CardBody>
            </Card>
          )}
        {this.state.currentStage === this.STAGE_FAILED &&
          !this.state.isBusy && (
            <Card>
              <CardBody>
                <Row>
                  {metadataService.getMessage("ResetPasswordFailed")}
                </Row>
              </CardBody>
            </Card>
          )}
        <Row className="justify-content-center">
          <Col xs={12} md={6}>
            <div className="text-center">
              {this.state.currentStage !== this.STAGE_VALIDATE_MFA && (
                <SlButton
                  name="Next"
                  onClick={this.handleSubmit}
                  disabled={!this.state.canMoveNext}
                />
              )}
              {this.state.pageError && (
                <FormFeedback
                  invalid
                  style={{ display: "block", textAlign: "center" }}
                >
                  {this.state.pageError}
                </FormFeedback>
              )}
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}
